import React from "react";
import Spaces from "../../sharedComponents/components/Spaces";

export default (props: any) => {
  
  return (<div className={"landing-page--v2-bg--shape2"}>
    
    <Spaces n={2}/>
    
    <div className={"container-lp"}>
      
      <section className={"landing-page--v2__side-by-side"}>
        
        <article className={"landing-page--v2__side-by-side__box landing-page--v2__side-by-side__box2"}>
          <h2 className={"landing-page--v2__title"}>
            Gagnez 50% de temps sur le tri des candidatures
          </h2>
          <Spaces n={0}/>
          <div className={"landing-page--v2__text"}>
            Myshortlist.co vous permet aux équipes RH et d'Opérationnels de collaborer à la création d'un questionnaire sur mesure pour chaque poste en
            définissant des critères de sélection hard & soft skills.
          </div>
        </article>
        
        <article className={"landing-page--v2__side-by-side__box landing-page--v2__side-by-side__box1"}>
          <div className={"landing-page--v2__video-container landing-page--v2__video-container--grey"}>
            <video width="100%" height="100%" playsInline={true} controls={false} autoPlay={true} loop={true} muted={true}>
              <source src="https://static.myshortlist.co/videos/v3_form.webm" type="video/webm"/>
              <source src="https://static.myshortlist.co/videos/v3_form.mp4" type="video/mp4"/>
              <source src="https://static.myshortlist.co/videos/v3_form.ogg" type="video/ogg"/>
              Your browser does not support the video tag.
            </video>
          </div>
        </article>
      
      </section>
    
    </div>
  
    <Spaces n={5}/>
  </div>);
}